import React from 'react'
import ReactDatePicker from 'react-datepicker'
import styled from 'styled-components'
import CalendatDay from '../../../../../generic/icons/IconLib/CalendarIcon'
import { he } from 'date-fns/locale'
import { format } from 'date-fns'

type Props = {
  selectedDates: Date[]
  onChange: React.Dispatch<React.SetStateAction<Date[]>> | ((dates: Date[]) => void)
}

const DatePickerRangeISO = ({
  selectedDates,
  onChange
}: Props) => {
  const handleChange = (dates: [Date | null, Date | null]) => {
    onChange(dates as unknown as Date[])
  }
  return (
    <ReactDatePicker
      startDate={selectedDates[0]}
      endDate={selectedDates[1]}
      selectsRange
      locale={he}
      onChange={handleChange}
      shouldCloseOnSelect
      popperProps={{ strategy: 'fixed' }}
      popperPlacement="bottom-end"
      customInput={
        <MainWrapper>
          <Input 
            value={selectedDates[0] ? format(selectedDates[0], 'dd/MM/yyyy') : ''}
            readOnly
          />
          -
          <Input 
            value={selectedDates[1] ? format(selectedDates[1], 'dd/MM/yyyy') : ''}
            readOnly
          />
          <IconWrapper>
            <CalendatDay />
          </IconWrapper>
        </MainWrapper>
      }
    />
  )
}
const MainWrapper = styled.label`
    position: relative;
    background: #fff;
    width: 240px;
    display: flex;
    justify-content: flex-end;
    gap: 0.5em;
    border-radius: 30px;
    padding: 1em ;
    color: #297F76;
    z-index: 2;
    box-shadow: 0px 1px 2px 2px rgba(41,127,118, 0.1);
    span {
      display: none;
    }
    
  
`
const IconWrapper = styled.div`
  position: absolute;
  top: calc(50% - 1.1em);
  left: 0.5em;
  width: 2em;
  height: 2em;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background: #80E081; */
  z-index: 99;
  border-radius: 50%;
  cursor: pointer;
  transition: 0.3s;
  &:hover {
    opacity: 0.8;
  }
  `
const Input = styled.input`
    border: none;
    direction: rtl;
    max-width: 80px;
    font-size: 1em;
    outline: none;
    color: #297F76;
    cursor: pointer;
    z-index: 55;
    /* padding: 0 0.5em; */
`
export default DatePickerRangeISO